import React, { useState } from "react";
import img1 from "../images/banner.jpg";
import cakeimg1 from "../images/spcake (1).jpg"
import cakeimg2 from "../images/spcake (2).jpg"
import cakeimg3 from "../images/spcake (3).jpg"
import cakeimg4 from "../images/spcake (4).jpg"
import cakeimg5 from "../images/spcake (5).jpg"
import cakeimg6 from "../images/spcake (6).jpg"
import cakeimg7 from "../images/spcake (7).jpg"
import cakeimg8 from "../images/spcake (8).jpg"
import cakeimg9 from "../images/spcake (9).jpg"
import cakeimg10 from "../images/spcake (10).jpg"
import cakeimg11 from "../images/spcake (11).jpg"
import cakeimg12 from "../images/spcake (12).jpg"
import cakeimg13 from "../images/spcake (13).jpg"
import cakeimg14 from "../images/spcake (14).jpg"
import cakeimg15 from "../images/spcake (15).jpg"
import cakeimg16 from "../images/spcake (16).jpg"
import cakeimg17 from "../images/spcake (17).jpg"
import cakeimg18 from "../images/spcake (18).jpg"


import { NavLink } from "react-router-dom";

const products = [
  { id: 1, name: "Birth Day", image: cakeimg1 },
    { id: 3, name: "Marriage & Engagement", image: cakeimg2 },
  { id: 4, name: "Anniversey", image: cakeimg3 },
  { id: 2, name: "Special Occision", image: cakeimg4 },
  { id: 2, name: "Special Occision", image: cakeimg5},
  { id: 2, name: "Special Occision", image: cakeimg6 },
  { id: 2, name: "Special Occision", image: cakeimg7 },
  { id: 2, name: "Special Occision", image: cakeimg8 },
  { id: 2, name: "Special Occision", image: cakeimg9 },
  { id: 2, name: "Special Occision", image: cakeimg10 },
  { id: 2, name: "Special Occision", image: cakeimg12 },
  { id: 2, name: "Special Occision", image: cakeimg13 },
  { id: 2, name: "Special Occision", image: cakeimg14 },
  { id: 2, name: "Special Occision", image: cakeimg15 },
  { id: 2, name: "Special Occision", image: cakeimg16 },
  { id: 2, name: "Special Occision", image: cakeimg17 },
  { id: 2, name: "Special Occision", image: cakeimg18 },
  { id: 2, name: "Special Occision", image: cakeimg11 },

 
];

const CakebyCategory = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="products-section" id="products">
     
      <div className="productlist-grid">
        {products.map((item) => (
          <div
            className="product-card"
        
          >
          
              <img  className="product-image" src={item.image} alt={item.name} />
              {/* <h4 className="product-name">{item.name}</h4> */}
       
   <a
              href={`https://wa.me/919666696905?text=Hi, I would like to order: ${encodeURIComponent(item.name)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-order-btn"
            >
              Order Now via WhatsApp
            </a>

          </div>
        
        ))}
      </div>

      {/* Modal View */}
      {/* {selectedImage && (
        <div className="modal" onClick={() => setSelectedImage(null)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside modal content
          >
            <button
              className="close-btn"
              onClick={() => setSelectedImage(null)}
              aria-label="Close"
            >
              &times;
            </button>
            <img src={selectedImage} alt="Large view" className="modal-img" />
          </div>
        </div>
      )} */}
    </section>
  );
};

export default CakebyCategory;
